// extracted by mini-css-extract-plugin
module.exports = {"vehicleAndHaulier":"paperTransport_vehicleAndHaulier__1HAHL"};